import { ShieldCheck, Sparkle, Image, UsersThree } from "@phosphor-icons/react";
import { BloomBadge } from "@/components/styleguide/ui/BloomBadge";
import { useAuth } from "../AuthContext";

export default function AdminSettings() {
  const { user } = useAuth();
  return (
    <div className="mx-auto max-w-3xl" data-testid="admin-settings">
      <h1 className="font-display text-3xl font-black tracking-tight text-foreground">Settings</h1>
      <p className="mt-1 text-sm font-semibold text-muted-foreground">Portal configuration and what's coming next.</p>

      <div className="mt-6 space-y-4">
        <div className="rounded-3xl border border-border bg-card p-5 shadow-soft">
          <div className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-teal/15"><ShieldCheck size={18} weight="bold" className="text-teal-ink" /></span>
            <p className="font-display text-base font-black text-foreground">Admin access</p>
          </div>
          <p className="mt-2 text-sm font-semibold text-muted-foreground">
            You are signed in as <b className="text-foreground">{user?.email}</b>. Admin access is granted to the owner email configured in
            <code className="mx-1 rounded bg-muted px-1.5 py-0.5 font-mono text-xs">OWNER_EMAIL</code> on the server. Additional admin users can be added later by promoting a user's role.
          </p>
        </div>

        <div className="rounded-3xl border-2 border-dashed border-border bg-card/60 p-5">
          <div className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary/25"><Sparkle size={18} weight="fill" className="text-secondary-ink" /></span>
            <p className="font-display text-base font-black text-foreground">AI Enrichment</p>
            <BloomBadge variant="neutral" className="px-2 py-0.5 text-[10px]">Phase 2</BloomBadge>
          </div>
          <p className="mt-2 text-sm font-semibold text-muted-foreground">
            Imported draft words will be enriched with child-friendly meanings, synonyms, antonyms, sentences and memory hints — always landing in the Review Queue, never publishing automatically.
          </p>
        </div>

        <div className="rounded-3xl border-2 border-dashed border-border bg-card/60 p-5">
          <div className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-blue/12"><Image size={18} weight="bold" className="text-blue-ink" /></span>
            <p className="font-display text-base font-black text-foreground">Word images</p>
            <BloomBadge variant="neutral" className="px-2 py-0.5 text-[10px]">Later</BloomBadge>
          </div>
          <p className="mt-2 text-sm font-semibold text-muted-foreground">Optional images per word with generate → review → approve workflow. Images stay hidden from children until approved.</p>
        </div>

        <div className="rounded-3xl border-2 border-dashed border-border bg-card/60 p-5">
          <div className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/12"><UsersThree size={18} weight="bold" className="text-primary-strong" /></span>
            <p className="font-display text-base font-black text-foreground">Additional admins</p>
            <BloomBadge variant="neutral" className="px-2 py-0.5 text-[10px]">Later</BloomBadge>
          </div>
          <p className="mt-2 text-sm font-semibold text-muted-foreground">The role architecture already supports multiple admins — a role management UI will land here.</p>
        </div>
      </div>
    </div>
  );
}
